module.exports = __webpack_public_path__ + "img/article3-1.3a394fb8.jpg";